import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import Dashboard from '@/store/dashboard/Dashboard.js'

import classModule from './learning/class'
import classDetail from './learning/classDetail'
import draftTimeTable from './learning/draftTimeTable'
import timeTable from './learning/timeTable'
import email from './notify/email'
import category from './other/category'
import search from './view/search.js'

// bus
import BusCheckin from '@/store/bus/BusCheckin/BusCheckin.js'
import BusStudentAttendanceDetail from '@/store/bus/BusStudentAttendanceDetail.js'
import bus from './bus/bus.js'
import busDetail from './bus/busDetail.js'
import BusStudentAttendance from './bus/BusStudentAttendance.js'
import BusStudents from './bus/BusStudents.js'

/**
 * SALE
/**
 * CLASS
 */
import semester from './course/semester'
import slot from './learning/slot'

import event from './learning/event'
import mark from './learning/mark'
import log from './other/log'
/**
 * MARK
 */
import ClassMark from './mark/ClassMark.js'
import ClassMarkInput from './mark/ClassMarkInput.js'
import Mark from './mark/Mark'
import MarkInput from './mark/MarkInput'
import StudentMark from './student/StudentMark'
/**
 * STUDENT
 */
import { axiosPlugin } from '@/plugins/axios'
import { setWith } from 'lodash-es'
import studentDashboard from './dashboard/studentDashboard'
import studentImporter from './importer/studentImporter.js'
import attendance from './student/attendance'
import student from './user/student'
import students from './user/students'
/**
 */
import departmentDashboard from '@/store/dashboard/departmentDashboard.js'
import role from './app/role'
import teacherDashboard from './dashboard/teacherDashboard'
import ownClassTeacher from './teacher/ownClassTeacher'
import teaching from './teacher/teaching'
import staff from './user/staff'
import teacher from './user/teacher'
import teachers from './user/teachers'

import academicPeriod from './academicPeriod/academicPeriod.js'
import division from './division/division'
import grade from './grade/grade'
import subjects from './subject/subjects'
import violation from './violation/violation'
/**
 * APPLICATIONS
 */
import { createStore } from 'vuex-extensions'
import app from './app/app'
import auth from './app/auth'
import user from './app/user'
import factor from './factor/factor'
import noti from './notify/noti'
import constant from './other/constant'
import rest from './other/rest'
import upload from './other/upload'
import policies from './policies/policies'
import view from './view'

import postCreate from './post/post-create'
import PostCreateAuto from './post/PostCreateAuto'

import Documents from '@/store/document/Documents.js'
import DocumentTypes from '@/store/document/DocumentTypes.js'
import Feedback from '@/store/feedback/Feedback.js'
import TeacherFeedback from '@/store/feedback/TeacherFeedback.js'
import OnlineStudy from '@/store/onlineStudy/OnlineStudy.js'
import TeachingReport from '@/store/teachingReport/TeachingReport.js'
import AcademicLevel from './academicLevel/AcademicLevel'
import AppHistory from './appHistory/AppHistory'
import ContactBook from './contactBook/ContactBook'
import StudentPostHistory from './contactBook/StudentPostHistory'
import SmsHistory from './smsHistory/SmsHistory'
import AttendanceDetail from './student/AttendanceDetail'
import Diligence from './student/Diligence'
import SubjectGroup from './subjectGroup/SubjectGroup'

import ClassNoteDetail from '@/store/teacher/ClassNoteDetail.js'
import ClassNotes from '@/store/teacher/ClassNotes.js'

import Integration from '@/store/integrations/Integration.js'

// meal
import Dishes from '@/store/dish/Dishes.js'
import FoodMenu from '@/store/foodMenu/FoodMenu.js'
import MealReport from '@/store/mealReport/MealReport.js'
import StudentMenuRegister from '@/store/studentMenuRegister/StudentMenuRegister.js'

// tuition
import taskProgress from '@/store/taskProgress/taskProgess'
import bankAccount from '@/store/tuitionFee/bankAccount'
import tuitionFeeCollection from '@/store/tuitionFee/collection.js'
import tuitionFeeGroup from '@/store/tuitionFee/group'
import tuitionFeeGroupHeadFee from '@/store/tuitionFee/groupHeadFee'
import tuitionFeeGroupStudent from '@/store/tuitionFee/groupStudent'
import tuitonFeeHeadFee from '@/store/tuitionFee/headFee.js'
import tuitionFeePeriod from '@/store/tuitionFee/period'
import tuitonFeePrice from '@/store/tuitionFee/price'
import tuitionFeePriceStudent from '@/store/tuitionFee/priceStudent'
import tuitionFeeReport from '@/store/tuitionFee/report'

// salary
import salaryCollection from '@/store/salary/collection'
import salaryGroup from '@/store/salary/group'
import salaryGroupHead from '@/store/salary/groupHead'
import salaryGroupTeacher from '@/store/salary/groupTeacher'
import salaryHead from '@/store/salary/head.js'
import salaryPeriod from '@/store/salary/period.js'
import salaryPrice from '@/store/salary/price.js'
import salaryPriceTeacher from '@/store/salary/priceTeacher.js'
import salaryReport from '@/store/salary/report.js'
// teacherDoc
import teacherDoc from './teacher-doc/teacherDoc'
// Task manager - Quản lý tác vụ, công việc
import task from '@/store/task/task'
// chưa biết đặt tên là gì
import absentRequest from '@/store/absent-request/AbsentRequest'
import classroom from './classroom/index.js'
import classTimeTable from './classTimeTable/index.js'
import docCategory from './doc-category/index.js'
import gradeDocument from './grade-document/index.js'

// student credit
import studentCredit from '@/store/studentCredit/index.js'
import lessonAttendance from './lesson-attendance/index.js'
import lesson from './lesson/index.js'
import studentCreditUsage from './studentCreditUsage/index.js'
// Exams
import exam from './exam/exam.js'
import examMark from './exam/examMark.js'
import examRoom from './exam/examRoom.js'
import gradeReview from './exam/gradeReview.js'
import indexing from './exam/indexing.js'
import monitor from './exam/monitor.js'
import room from './exam/room.js'
import roomSubject from './exam/roomSubject.js'
import studentExam from './exam/studentExam.js'
import subjectExamGroup from './exam/subjectExamGroup.js'
import teacherExam from './exam/teacherExam.js'
import projectCouncil from './project-council/index.js'
import projectTopic from './project-topic/index.js'
import projectWish from './project-wish/index.js'
import researchCouncil from './research-council/index.js'
import researchTopic from './research-topic/index.js'
import subjectExam from './subjectExam/subjectExam.js'
// Grade-mark
import gradeClassMark from './grade-mark/gradeClassMark.js'
import gradeClassMarkStudent from './grade-mark/gradeClassMarkStudent.js'
import gradeMark from './grade-mark/gradeMark.js'
import orderCheck from './order-check/index.js'
import order from './order/index.js'

import book from './book/index.js'
import bookCategory from './category/index.js'
import tool from './tool/index.js'

// Evaluate
import department from './department/index.js'
import evaluateCriteria from './evaluate-criteria/evaluate-criteria.js'
import evaluateStudent from './evaluate-student/evaluate-student.js'
import evaluateTemplate from './evaluate-template/evaluate-template.js'
import evaluate from './evaluate/evaluate.js'

// CRM
import appointment from './lead/appointment.js'
import lead from './lead/lead.js'
import leadConfig from './lead/leadConfig.js'
import leadLog from './lead/log.js'
import product from './lead/product.js'
import scheduleVacation from './schedule-vacation/index.js'
import tuitionFeeClassSetup from './tuitionFee/class-setup.js'

import configtaskroles from './config_task_roles/config_task_roles.js'
import tasknew from './task-new/task-new.js'
import holiday from './holiday/holiday.js'

Vue.use(Vuex)

export default createStore(Vuex.Store, {
  plugins: [
    createPersistedState({
      key: 'lms',
      paths: [
        'auth.user',
        'auth.policies',
        'auth.role',
        'auth.isAuthenticated',
        'auth.jwt',
        'app.currentSchoolYear',
        'app.currentSemester',
      ],
    }),
    axiosPlugin,
  ],
  modules: {
    busDetail,
    bus,
    BusStudents,
    BusStudentAttendance,
    BusStudentAttendanceDetail,
    BusCheckin,
    Dashboard,
    rest,
    attendance,
    auth,
    view,
    user,
    staff,
    teacher,
    teachers,
    teaching,
    ownClassTeacher,
    class: classModule,
    semester,
    category,
    email,
    constant,
    slot,
    event,
    upload,
    noti,
    app,
    policies,
    role,
    log,
    mark,
    classDetail,
    timeTable,
    draftTimeTable,
    teacherDashboard,
    departmentDashboard,
    students,
    student,
    studentDashboard,
    studentImporter,
    division,
    grade,
    academicPeriod,
    factor,
    subjects,
    violation,
    search,
    postCreate,
    PostCreateAuto,
    MarkInput,
    Mark,
    StudentMark,
    SubjectGroup,
    ContactBook,
    SmsHistory,
    AppHistory,
    StudentPostHistory,
    AttendanceDetail,
    AcademicLevel,
    Diligence,
    ClassMarkInput,
    ClassMark,
    OnlineStudy,
    Feedback,
    TeacherFeedback,
    DocumentTypes,
    Documents,
    ClassNoteDetail,
    ClassNotes,
    TeachingReport,
    Dishes,
    FoodMenu,
    StudentMenuRegister,
    MealReport,
    Integration,
    tuitonFeeHeadFee,
    tuitionFeeGroup,
    tuitionFeeGroupStudent,
    tuitionFeeGroupHeadFee,
    tuitonFeePrice,
    tuitionFeePriceStudent,
    tuitionFeePeriod,
    bankAccount,
    tuitionFeeReport,
    tuitionFeeCollection,
    taskProgress,
    task,
    absentRequest,
    // salary
    salaryCollection,
    salaryGroup,
    salaryGroupHead,
    salaryGroupTeacher,
    salaryHead,
    salaryPeriod,
    salaryPrice,
    salaryPriceTeacher,
    salaryReport,
    teacherDoc,
    studentCredit,
    studentCreditUsage,
    docCategory,
    gradeDocument,
    classTimeTable,
    lesson,
    configtaskroles,
    tasknew,
    lessonAttendance,
    // exam
    exam,
    subjectExam,
    subjectExamGroup,
    room,
    studentExam,
    examRoom,
    indexing,
    examMark,
    roomSubject,
    teacherExam,
    monitor,
    gradeReview,
    classroom,
    projectTopic,
    projectWish,
    projectCouncil,
    researchTopic,
    researchCouncil,
    bookCategory,
    book,
    // grade-mark
    gradeMark,
    gradeClassMark,
    gradeClassMarkStudent,
    order,
    orderCheck,
    tool,
    // evaluate
    evaluate,
    evaluateCriteria,
    evaluateStudent,
    evaluateTemplate,
    department,
    // CRM
    lead,
    leadLog,
    leadConfig,
    appointment,
    product,
    tuitionFeeClassSetup,
    scheduleVacation,
    holiday,
  },
  mixins: {
    mutations: {
      changeState: function (state, changed) {
        Object.entries(changed).forEach(([name, value]) => {
          state[name] = value
        })
      },
      changeDeepState: function (state, changed) {
        Object.entries(changed).forEach(([firstChildName, diff]) => {
          const firstChildValue = { ...state[firstChildName] }
          Object.entries(diff).forEach(([path, diffValue]) => {
            setWith(firstChildValue, path, diffValue)
          })
          state[firstChildName] = firstChildValue
        })
      },
    },
  },
})
